import React, { Fragment, useState, useEffect } from 'react';
import { Form, Grid, Button, Message } from 'semantic-ui-react';

export const CNVersion = (props) => {
  const {
    CurrentCNVersion,
    LatestCNVersion,
    CNUpdateDeadline,
  } = props.cnVersionInformation;

  const [topMessage, setTopMessage] = useState(null);
  const [upToDate, setUpToDate] = useState(true);

  useEffect(() => {
    setTopMessage(
      getTopMessage(
        CurrentCNVersion,
        LatestCNVersion,
        CNUpdateDeadline,
        props.updateInProgress,
        props.previewInProgress
      )
    );
    setUpToDate(CurrentCNVersion === LatestCNVersion);
  }, [
    CurrentCNVersion,
    LatestCNVersion,
    CNUpdateDeadline,
    props.updateInProgress,
    props.previewInProgress,
  ]);

  return (
    <Fragment>
      <Form>
        <Grid>
          <Grid.Row>{topMessage}</Grid.Row>
          <Grid.Row
            className={
              CurrentCNVersion === LatestCNVersion
                ? 'justify-content-center'
                : 'justify-content-flex-end'
            }
          >
            <Grid.Column
              width={3}
              className="display--flex cn-version-information-current-version-column"
              style={{
                marginLeft: CurrentCNVersion === LatestCNVersion ? '3%' : '0%',
              }}
            >
              <label>Current CN Version: </label>
              <span className="font-bold cn-version-information-current-version">
                {CurrentCNVersion}
              </span>
            </Grid.Column>
            {!upToDate && (
              <Fragment>
                <Grid.Column
                  width={4}
                  className="display--flex cn-version-information-latest-version-column"
                >
                  <label>Latest CN Version Available: </label>
                  <span className="font-bold cn-version-information-latest-version">
                    {LatestCNVersion}
                  </span>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Button
                    onClick={props.handleCNPreviewClick}
                    disabled={
                      props.updateInProgress ||
                      props.previewInProgress ||
                      props.cnVersionUpdateEnqueueloading
                    }
                    loading={props.cnPreviewEnqueuedLoading}
                  >
                    Preview CN Update
                  </Button>
                </Grid.Column>
                <Grid.Column
                  width={4}
                  className="cn-version-update-button-column"
                >
                  <Button
                    color={'orange'}
                    onClick={props.handleUpdateClick}
                    disabled={
                      props.updateInProgress ||
                      props.previewInProgress ||
                      props.cnVersionUpdateEnqueueloading
                    }
                    loading={props.cnVersionUpdateEnqueueloading}
                  >
                    Update CN Version
                  </Button>
                </Grid.Column>
              </Fragment>
            )}
          </Grid.Row>
        </Grid>
      </Form>
    </Fragment>
  );
};

const getTopMessage = (
  currentCNVersion,
  latestCNVersion,
  updateByDate,
  updateInProgress,
  previewInProgress
) => {
  if (updateInProgress) {
    return (
      <Message info className="text-center font-bold cn-version-top-message">
        <Message.Content>CN Version Update In Progress</Message.Content>
      </Message>
    );
  } else if (previewInProgress) {
    return (
      <Message info className="text-center font-bold cn-version-top-message">
        <Message.Content>CN Version Update Preview In Progress</Message.Content>
      </Message>
    );
  } else if (currentCNVersion !== latestCNVersion) {
    const outOfDatemessage = updateByDate ? (
      <p>
        The Current CN Version is Out of Date and Must be Updated by
        <span className="font-bold">&nbsp; {updateByDate}</span>
      </p>
    ) : (
      <p> The Current CN Version is Out of Date and Must be Updated</p>
    );

    return (
      <Message
        negative
        className="font-bold text-center cn-version-top-message"
      >
        <Message.Content>{outOfDatemessage}</Message.Content>
      </Message>
    );
  }
  return (
    <Message info className="text-center font-bold cn-version-top-message">
      <Message.Content>The CN Version is Up to Date</Message.Content>
    </Message>
  );
};



// WEBPACK FOOTER //
// ./src/pages/controlinformation/components/CNVersion.js